import React from "react";
import { Col, Row } from "@folio/stripes/components";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { FormattedMessage, useIntl } from "react-intl";
import { createPiidReportSchema } from "../../../utils/validationUtils";
import { generatePiidReport } from "../../../api/reportsService";
import { transformFormToApiParams, } from "../../../types/reports/piidReport";
import { PiidExportParamsRegistrationAgencyEnum } from "../../../types/Api";
import { InfoBox, InfoBoxTypeEnum } from "../../InfoBox";
import { useReportMutation } from "../../../hooks/useReportMutation";
import { RegistrationAgencySelect } from "./RegistrationAgencySelect";
import { ReportSubmitSection } from "./ReportSubmitSection";
var getDefaultValues = function () { return ({
    registrationAgency: PiidExportParamsRegistrationAgencyEnum.ISBN,
}); };
export var PiidReportForm = function () {
    var formatMessage = useIntl().formatMessage;
    var _a = useForm({
        resolver: zodResolver(createPiidReportSchema(formatMessage)),
        defaultValues: getDefaultValues(),
    }), control = _a.control, handleSubmit = _a.handleSubmit;
    var reportMutation = useReportMutation({
        reportType: "piid-report",
        generateReport: function (ky, data) {
            var apiParams = transformFormToApiParams(data);
            return generatePiidReport(ky, apiParams);
        },
        successMessageId: "ui-br-agency.outputs.piid-report.success.generate",
        errorMessageId: "ui-br-agency.outputs.piid-report.error.generate",
    });
    return (React.createElement("form", { onSubmit: handleSubmit(function (data) { return reportMutation.mutate(data); }) },
        React.createElement("h2", null,
            React.createElement(FormattedMessage, { id: "ui-br-agency.outputs.report.piid-report" })),
        React.createElement("p", null,
            React.createElement(FormattedMessage, { id: "ui-br-agency.outputs.piid-report.description" })),
        React.createElement(Row, null,
            React.createElement(Col, { xs: 12, md: 6 },
                React.createElement(RegistrationAgencySelect, { control: control, name: "registrationAgency" }))),
        React.createElement(Row, null,
            React.createElement(Col, { xs: 12 },
                React.createElement(InfoBox, { type: InfoBoxTypeEnum.INFO },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.outputs.piid-report.info.generationTime" })))),
        React.createElement(ReportSubmitSection, { reportJob: reportMutation.reportJob, isLoading: reportMutation.isLoading, generateButtonId: "ui-br-agency.outputs.piid-report.button.generate", successMessage: reportMutation.successMessage, onSuccessDismiss: reportMutation.clearSuccessMessage, errorModalOpen: reportMutation.errorModalOpen, errorMessage: reportMutation.errorMessage, onErrorClose: reportMutation.closeErrorModal })));
};
